module.exports = __webpack_public_path__ + "static/media/burger.46b46570.svg";